<template>
  <CCard>
    <CCardHeader class="d-flex ">
      <h2
        v-if="id"
        class="mb-0"
      >
        Edit Studio
      </h2>
      <h2
        v-else
        class="mb-0"
      >
        Add Studio
      </h2>
    </CCardHeader>
    <CCardBody>
      <form
        v-if="!id || loaded"
        autocomplete="off"
        @submit.prevent="submit"
      >
        <CInput
          v-model="form.name"
          label="Name"
          :add-input-classes="{'is-invalid': hasError('name')}"
          :invalid-feedback="getError('name')"
        />
        <CInput
          v-model="form.location"
          label="Location"
          :add-input-classes="{'is-invalid': hasError('location')}"
          :invalid-feedback="getError('location')"
        />

        <AppSelect
          v-model="form.time_zone"
          :options="time_zones"
          label="Time Zone"
          placeholder="Select Time Zone"
          :invalid-feedback="getError('time_zone')"
        />
        <!--        <CButton type="button" @click="$router.push({name: 'Studios'})" color="secondary" variant="outline" class="mr-3">Back</CButton>-->
        <CButton
          type="submit"
          color="primary"
        >
          Save
        </CButton>
      </form>
      <div
        v-else
        class="d-flex py-5 justify-content-center align-items-center"
      >
        <CSpinner />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";
import AppSelect from '@/components/AppSelect.vue';

export default {
  name: "AddStudio",
  components: { AppSelect },
  mixins: [hasApiValidation],
  props: ['id'],
  data() {
    return {
      time_zones: [
        {
          value: 'America/New_York', label: 'Eastern',
        }, {
          value: 'America/Chicago', label: 'Central',
        }, {
          value: 'America/Denver', label: 'Mountain',
        }, {
          value: 'America/Phoenix', label: 'Mountain no DST',
        }, {
          value: 'America/Los_Angeles', label: 'Pacific',
        }, {
          value: 'America/Anchorage', label: 'Alaska',
        }, {
          value: 'America/Adak', label: 'Hawaii',
        }, {
          value: 'Pacific/Honolulu', label: 'Hawaii no DST'
        },
      ],
      form: {
        name: '',
        location: null,
        time_zone: null,
      },
      loaded: false,
    }
  },
  mounted() {
    if (this.id) {
      this.fetchData();
    }
  },
  methods: {
    submit() {
      this.setErrors({});
      this.loading = true;
      if (this.id) {
        this.update();
      } else {
        this.save();
      }
    },
    fetchData() {
      this.$http.get('/studios/' + this.id).then(({data}) => {
        this.form.name = data.data.name;
        this.form.location = data.data.location;
        this.form.time_zone = data.data.time_zone;
        this.loading = false;
        this.loaded = true;
      }).catch(({response}) => {
        this.loading = false;
        this.$router.push({name: 'Studios'}).then(()=>{
          this.$toast.error('This studio is not available')
        })
      })
    },
    dataForSSelect(data, name = "Select") {
      let arr = [{
        value: null,
        label: name,
        disabled: true,
      }]
      data.forEach(item => {
        arr.push({
          value: item.value,
          label: item.label + ' ('+item.value+')',
          // text: item.name
        })
      })
      return arr
    },
    updateData(data, type) {
      this.form[type] = data;
    },
    save() {
      this.$http.post('/studios', this.form).then((data) => {
        this.$toast.success('Created');
        this.$router.push({name: 'Studios'})
        this.loading = false;
      }).catch(({response}) => {
        this.$toast.error(response.data.message);
        this.setErrors(response.data.errors);
        this.loading = false;
      })
    },
    update() {
      this.$http.put('/studios/' + this.id, this.form).then((data) => {
        this.$toast.success('Updated');
        this.$router.push({name: 'Studios'})
        this.loading = false;
      }).catch(({response}) => {
        if(response.status === 404){
          this.$router.push({name: 'Studios'}).then(()=>{
            this.$toast.error('This studio is not available')
          })
        } else {
          this.$toast.error(response.data.message);
          this.loading = false;
          this.setErrors(response.data.errors);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>